

frappe.provide("frappe.ui");
frappe.provide("frappe.web_form");
import EventEmitterMixin from '../../../../../frappe/frappe/public/js/frappe/event_emitter';
import Workflow from './workflow.js';
import EventObserver from './EventObserver'

export default class WebForm extends frappe.ui.FieldGroup {
    constructor(opts) {
        super();
        Object.assign(this, opts);
        frappe.web_form = this;
        frappe.web_form.events = {};
        Object.assign(frappe.web_form.events, EventEmitterMixin);
        this.current_section = 0;
        this.is_dialog = true; //TODO: We need to fix layout.js, it should detect webforms.


    }

    prepare(web_form_doc, doc) {
        Object.assign(this, web_form_doc);
        this.fields = web_form_doc.web_form_fields;
        this.doc = doc;
        this.workflow = new Workflow(web_form_doc.doc_type);
        // locals[web_form_doc.doc_type] = [];
        // locals[web_form_doc.doc_type][doc.name] = doc;
        // this.set_globals();
    }

    // set_globals() {
    //     frappe.session.user = frappe.boot.user.name;
    //     frappe.session.user_email = frappe.boot.user.email;
    //     //frappe.session.user_fullname = frappe.user_info().fullname;
    //
    //     frappe.user_defaults = frappe.boot.user.defaults;
    //     frappe.user_roles = frappe.boot.user.roles;
    //     frappe.sys_defaults = frappe.boot.sysdefaults;
    //
    //     frappe.ui.py_date_format = frappe.boot.sysdefaults.date_format.replace('dd', '%d').replace('mm', '%m').replace('yyyy', '%Y');
    //     frappe.boot.user.last_selected_values = {};
    // }

    make() {
        const me = this;
        if (typeof this.setup === "function") this.setup(this)
        super.make(); //This overwrites default values.
        $.each(this.fields_list, function (i, field) {
            if (field.df.fieldtype == "Autocomplete" && field.awesomplete) {
                function update_autocomplete_label(label) {
                    let l = field.$input.nextAll('.text-muted');
                    if (l.length == 0) {
                        l = $("<small/>").addClass('text-muted');
                        l.insertAfter(field.$input);
                    }
                    l.html(label);
                }

                me.on(field.df.fieldname, () => {
                    //let selected = field.get_data().find(x => x.value == field.value);
                    let selected = field._data.find(x => x.value == field.value);
                    if (selected) update_autocomplete_label(selected.label);
                });
            }
        });
        //this.set_field_values();
        this.refresh();

        //Fix for sub table delete all rows not working in web form.
        const remove_all_rows_button = this.wrapper.find('.grid-buttons .grid-remove-all-rows');
        remove_all_rows_button.prop('disabled', true);
        // if (!this.doc) this.doc = this.get_values(true);
        // $('div.awesomplete input').on("awesomplete-open", function(e) {
        // 	$(this).next("ul").find("li:last-child").hide();
        // 	$(this).next("ul").find("li:last-child").hide();
        // });
        frappe.init_document_script && frappe.init_document_script();

        frappe.web_form.events.trigger('setup', this);
        this.page = $("div#page-" + this.route.replaceAll('/', '-'));
        this.web_form_actions = this.page.find(".web-form-actions");
        this.actions = this.web_form_actions.find(".actions-btn-group .dropdown-menu");
        this.actions_btn_group = this.web_form_actions.find(".actions-btn-group");

        if (this.introduction_text) this.set_form_description(this.introduction_text);
        if (this.allow_print && !this.is_new) this.setup_print_button();
        if (this.allow_delete && !this.is_new && this.allow_edit) this.setup_delete_button();
        if (this.is_new || !this.allow_edit) this.setup_cancel_button();
        if (this.allow_edit || this.is_new) this.setup_primary_action();
        if (this.allow_workflow_actions && this.allow_edit) {
            this.workflow.setup(this.doc).then(r => {
                if (this.workflow.workflow_name) me.setup_workflow_action();
            });
        }
        this.setup_previous_next_button();
        this.toggle_section();
        $(".link-btn").remove();

        // webform client script
        frappe.init_client_script && frappe.init_client_script();

        frappe.web_form.events.trigger('after_load', this);
        this.after_load && this.after_load();

        // add warning when backing out of changed page
        $(window).unload(function(){
            if (me.doc.has_changes) {
                const save_dialog = new frappe.ui.Dialog({
                    title: __("Save changes?"),
                    primary_action_label: __("Save"),
                    primary_action: () => {
                        me.save();
                    }
                });
                save_dialog.set_message(__("Save Changes?"));
                save_dialog.show();
            }
        });
    }

    on(fieldname, handler) {
        let field = this.fields_dict[fieldname];
        if (!field.changeObserver) field.changeObserver = new EventObserver();
        field.changeObserver.subscribe(handler);
        field.df.change = () => {
            field.changeObserver.broadcast(field, field.value);
            // handler(field, field.value);
        };
    }

    setup_listeners() {
        // Event listener for triggering Save/Next button for Multi Step Forms
        // Do not use `on` event here since that can be used by user which will render this function useless
        // setTimeout has 200ms delay so that all the base_control triggers for the fields have been run
        let me = this;

        if (!me.is_multi_step_form) {
            return;
        }

        for (let field of $(".input-with-feedback")) {
            $(field).change((e) => {
                setTimeout(() => {
                    e.stopPropagation();
                    me.toggle_buttons();
                }, 200);
            });
        }
    }

    set_sections() {
        if (this.sections.length) return;

        this.sections = $(`.form-section`);
    }

    setup_previous_next_button() {
        let me = this;

        if (!me.is_multi_step_form) {
            return;
        }

        $('.web-form-footer').after(`
			<div id="form-step-footer" class="pull-right">
				<button class="btn btn-primary btn-previous btn-sm ml-2">${__("Previous")}</button>
				<button class="btn btn-primary btn-next btn-sm ml-2">${__("Next")}</button>
			</div>
		`);

        $('.btn-previous').on('click', function () {
            let is_validated = me.validate_section();

            if (!is_validated) return;

            /**
				The eslint utility cannot figure out if this is an infinite loop in backwards and
				throws an error. Disabling for-direction just for this section.
				for-direction doesnt throw an error if the values are hardcoded in the
				reverse for-loop, but in this case its a dynamic loop.
				https://eslint.org/docs/rules/for-direction
             */
            /* eslint-disable for-direction */
            for (let idx = me.current_section; idx < me.sections.length; idx--) {
                let is_empty = me.is_previous_section_empty(idx);
                me.current_section = me.current_section > 0 ? me.current_section - 1 : me.current_section;

                if (!is_empty) {
                    break;
                }
            }
            /* eslint-enable for-direction */
            me.toggle_section();
        });

        $('.btn-next').on('click', function () {
            let is_validated = me.validate_section();

            if (!is_validated) return;

            for (let idx = me.current_section; idx < me.sections.length; idx++) {
                let is_empty = me.is_next_section_empty(idx);
                me.current_section = me.current_section < me.sections.length ? me.current_section + 1 : me.current_section;

                if (!is_empty) {
                    break;
                }
            }
            me.toggle_section();
        });
    }

    get_field_status(control) {
        // like in case of a dialog box
        if (cint(control.df.hidden)) {
            return "None";
        } else if (cint(control.df.hidden_due_to_dependency)) {
            return "None";
        } else if (cint(control.df.read_only)) {
            return "Read";
        } else if (control.grid && cint(control.grid.df.read_only)) {
            return "Read";
        } else if (!frappe.web_form.allow_edit) {
            return "Read";
        }
        return "Write";
    }

    set_field_values() {
        if (this.doc && this.doc.name) this.set_values(this.doc);
        else return;
    }

    set_default_values() {
        let values = frappe.utils.get_query_params();
        delete values.new;
        this.set_values(values);
    }

    set_form_description(intro) {
        let intro_wrapper = document.getElementById('introduction');
        intro_wrapper.innerHTML = intro;
    }

    add_button(name, type, action, wrapper_class = ".web-form-actions-buttons", title) {
        const button = $('<button/>')
            .addClass("btn btn-" + type + " btn-sm ml-1 mr-1")
            .html(name)
            .click(action);
        if (title) button.prop("title", title).data( "toggle", "tooltip" ).tooltip();
        button.appendTo(wrapper_class);
    }

    hide_button(name, type, wrapper_class = ".web-form-actions-buttons") {
        $(wrapper_class + " button.btn.btn-" + type + ":contains(" + name + ")").hide();
    }

    add_button_to_header(name, type, action, title) {
        this.add_button(name, type, action, '.web-form-actions-buttons', title);
    }

    add_button_to_footer(name, type, action, title) {
        this.add_button(name, type, action, '.web-form-footer-buttons', title);
    }

    setup_action (name, type, action, title) {
        this.add_button_to_header(name, type, action, title);
        this.add_button_to_footer(name, type, action, title);
    }

    setup_primary_action() {
        this.add_button_to_header(this.button_label || "Save", "primary", () =>
            this.save()
        , "Saves changes");

        this.add_button_to_footer(this.button_label || "Save", "primary", () =>
            this.save()
        , "Saves changes");
    }

    remove_primary_action() {
        this.hide_button(this.button_label || "Save", "primary")
        this.hide_button(this.button_label || "Save", "primary", '.web-form-footer')
    }

    //bugfix for get_value sometimes returning undefined.  blame the field_group.js get_value function.
    get_value(key) {
		var f = this.fields_dict[key];
        let val = f && (f.get_value ? f.get_value() : null);
        if (val === undefined) val = f && (f.get_modal_value ? f.get_modal_value() : null);
        return val;
    }

    dirty() {
        this.doc.__unsaved = 1;

        this.events.trigger('dirty');
    }
    workflow_confirm_message(transition) {
        return "Are you sure? This action cannot be reversed."
    }
    workflow_action(d) {
        let me = this;
        // workflow action triggered
        if (!me.validate(true)) return;

        frappe.confirm(me.workflow_confirm_message(d), () => {
            // set the workflow_action for use in form scripts
            me.selected_workflow_action = d.action;

            frappe.run_serially([
                () => me.save(true),
                () => me.events.trigger('before_workflow_action', this),
                () => {
                    if (!me.validate(true)) return Promise.resolve();
                    return me.workflow.apply_workflow(me.doc, d.action)
                    .then((doc) => {
                        // me.doc = doc;
                        // me.set_field_values();
                        const redirect_url = me.success_url || window.location.pathname;
                        me.handle_success(doc, 'Action "' + me.selected_workflow_action + '" completed.', redirect_url);
                        me.selected_workflow_action = null;
                    })
                },
                () => me.events.trigger('after_workflow_action', this)
            ]);
        });
    }
    setup_workflow_action() {
        var me = this;

        // if the loaded doc is dirty, don't show workflow buttons
        // if (frappe.form_dirty) {
        //     return;
        // }

        // Add the workflow transition button.  Use a dropdown if there are more than one.
        if (me.workflow.transitions.length > 1) {

            me.workflow.transitions.forEach(d => {
                me.add_action_item(__(d.action), function () {
                    workflow_action(d);
                });
            });
        } else if (me.workflow.transitions.length == 1) {
            let d = me.workflow.transitions[0]
            this.setup_action(__(d.action), "secondary", () => me.workflow_action(d), "Save and submit document.");
        }
        if (!me.workflow.allow_edit) {
            // Set doc to read-only.
            me.set_read_only();
        }

    }

    set_read_only() {
        this.setup_cancel_button();
        this.fields.forEach(df => {
            df.read_only = 1;
        });
    }

    add_action_item(label, click, standard) {
        return this.add_dropdown_item({
            label,
            click,
            standard,
            parent: this.actions
        });
    }

    setup_cancel_button() {
        this.setup_action(__("Close"), "light", () => this.cancel());
    }

    setup_delete_button() {
        this.setup_action(
            '<i class="fa fa-trash" aria-hidden="true"></i>',
            "light",
            () => this.delete()
        );
    }

    setup_print_button() {
        this.setup_action(
            '<i class="fa fa-print" aria-hidden="true"></i>',
            "light",
            () => this.print()
        );
    }

    validate_section() {
        if (this.allow_incomplete) return true;

        let fields = $(`.form-section:eq(${this.current_section}) .form-control`);
        let errors = [];
        let invalid_values = [];

        for (let field of fields) {
            let fieldname = $(field).attr("data-fieldname");
            if (!fieldname) continue;

            field = this.fields_dict[fieldname];

            if (field.get_value) {
                let value = field.get_value();
                if (field.df.reqd && is_null(typeof value === 'string' ? strip_html(value) : value)) errors.push(__(field.df.label));

                if (field.df.reqd && field.df.fieldtype === 'Text Editor' && is_null(strip_html(cstr(value)))) errors.push(__(field.df.label));

                if (field.df.invalid) invalid_values.push(__(field.df.label));
            }
        }

        let message = '';
        if (invalid_values.length) {
            message += __('Invalid values for fields:') + '<br><br><ul><li>' + invalid_values.join('<li>') + '</ul>';
        }

        if (errors.length) {
            message += __('Mandatory fields required:') + '<br><br><ul><li>' + errors.join('<li>') + '</ul>';
        }

        if (invalid_values.length || errors.length) {
            frappe.msgprint({
                title: __('Error'),
                message: message,
                indicator: 'orange'
            });
        }

        return !(errors.length || invalid_values.length);
    }

    toggle_section() {
        if (!this.is_multi_step_form) return;

        this.toggle_previous_button();
        this.hide_sections();
        this.show_section();
        this.toggle_buttons();
    }

	toggle_buttons() {
		for (let idx = this.current_section; idx < this.sections.length; idx++) {
			if (this.is_next_section_empty(idx)) {
				this.show_save_and_hide_next_button();
			} else {
				this.show_next_and_hide_save_button();
				break;
			}
		}
	}

    is_next_section_empty(section) {
        if (section + 1 > this.sections.length) return true;

        let _section = $(`.form-section:eq(${section + 1})`);
        let visible_controls = _section.find(".frappe-control:not(.hide-control)");

        return !visible_controls.length ? true : false;
    }

    is_previous_section_empty(section) {
        if (section - 1 > this.sections.length) return true;

        let _section = $(`.form-section:eq(${section - 1})`);
        let visible_controls = _section.find(".frappe-control:not(.hide-control)");

        return !visible_controls.length ? true : false;
    }

    show_save_and_hide_next_button() {
        $('.btn-next').hide();
        $('.web-form-footer').show();
    }

    show_next_and_hide_save_button() {
        $('.btn-next').show();
        $('.web-form-footer').hide();
    }

    toggle_previous_button() {
        this.current_section == 0 ? $('.btn-previous').hide() : $('.btn-previous').show();
    }

    show_section() {
        $(`.form-section:eq(${this.current_section})`).show();
    }

    hide_sections() {
        for (let idx=0; idx < this.sections.length; idx++) {
            if (idx !== this.current_section) {
                $(`.form-section:eq(${idx})`).hide();
            }
        }
    }

    /*
	* Add label to given drop down menu. If label, is already contained in the drop
	* down menu, it will be ignored.
	* @param {string} label - Text for the drop down menu
	* @param {function} click - function to be called when `label` is clicked
	* @param {Boolean} standard
	* @param {object} parent - DOM object representing the parent of the drop down item lists
	* @param {string} shortcut - Keyboard shortcut associated with the element
	* @param {Boolean} show_parent - Whether to show the dropdown button if dropdown item is added
	*/
    add_dropdown_item({label, click, standard, parent, shortcut, show_parent = true}) {
        if (show_parent) {
            parent.parent().removeClass("hidden");
        }

        let $li;
        if (shortcut) {
            let shortcut_obj = this.prepare_shortcut_obj(shortcut, click, label);
            $li = $(`<li><a class="grey-link dropdown-item" href="#" onClick="return false;">
				<span class="menu-item-label">${label}</span>
				<span class="text-muted pull-right">${shortcut_obj.shortcut_label}</span>
			</a><li>`);
            frappe.ui.keys.add_shortcut(shortcut_obj);
        } else {
            $li = $(`<li><a class="grey-link dropdown-item" href="#" onClick="return false;">
				<span class="menu-item-label">${label}</span></a><li>`);
        }
        var $link = $li.find("a").on("click", click);

        if (this.is_in_group_button_dropdown(parent, 'li > a.grey-link', label)) return;

        if (standard) {
            $li.appendTo(parent);
        } else {
            this.divider = parent.find(".divider");
            if (!this.divider.length) {
                this.divider = $('<li class="divider user-action"></li>').prependTo(parent);
            }
            $li.addClass("user-action").insertBefore(this.divider);
        }

        // alt shortcut
        // frappe.ui.keys
        // 	.get_shortcut_group(parent.get(0))
        // 	.add($link, $link.find('.menu-item-label'));

        return $link;
    }

    prepare_shortcut_obj(shortcut, click, label) {
        let shortcut_obj;
        // convert to object, if shortcut string passed
        if (typeof shortcut === 'string') {
            shortcut_obj = {shortcut};
        } else {
            shortcut_obj = shortcut;
        }
        // label
        if (frappe.utils.is_mac()) {
            shortcut_obj.shortcut_label = shortcut_obj.shortcut.replace('Ctrl', '⌘');
        } else {
            shortcut_obj.shortcut_label = shortcut_obj.shortcut;
        }
        // actual shortcut string
        shortcut_obj.shortcut = shortcut_obj.shortcut.toLowerCase();
        // action is button click
        if (!shortcut_obj.action) {
            shortcut_obj.action = click;
        }
        // shortcut description can be button label
        if (!shortcut_obj.description) {
            shortcut_obj.description = label;
        }
        // page
        shortcut_obj.page = this;
        return shortcut_obj;
    }

    /*
    * Check if there already exists a button with a specified label in a specified button group
    * @param {object} parent - This should be the `ul` of the button group.
    * @param {string} selector - CSS Selector of the button to be searched for. By default, it is `li`.
    * @param {string} label - Label of the button
    */
    is_in_group_button_dropdown(parent, selector, label) {

        if (!selector) selector = 'li';

        if (!label || !parent) return false;

        const result = $(parent).find(`${selector}:contains('${label}')`)
            .filter(function () {
                let item = $(this).html();
                return $(item).attr('data-label') === label;
            });
        return result.length > 0;
    }

    validate(showErrorMessage) {
        frappe.web_form.events.trigger('on_validate', this);
        var missing = [];
        var invalid = [];
        for (var key in this.fields_dict) {
            var f = this.fields_dict[key];
            if (f.get_value) {
                var v = f.get_value();
                if (f.df.reqd && is_null(v))
                    missing.push(__(f.df.label));
                else if (f.df.invalid)
                    invalid.push(__(f.df.label));
            }
        }
        if ((missing.length || invalid.length) && showErrorMessage) {
            var msg = ""
            if (missing.length)
                msg += __('Following fields have missing values:') +
                    '<br><br><ul><li>' + missing.join('<li>') + '</ul>' +
                    '<br><br>';
            if (invalid.length)
                msg += __('Following fields have invalid values:') +
                    '<br><br><ul><li>' + invalid.join('<li>') + '</ul>'
            frappe.msgprint({
                title: __('Missing or Invalid Values'),
                message: msg,
                indicator: 'orange'
            });

        }
        frappe.web_form.events.trigger('validate', {'missing': missing, 'invalid': invalid});
        return missing.length + invalid.length == 0;
    }

    save(silent) {
        this.cancelSave = false;
        if (!this.validate(!silent) && !this.allow_incomplete) return;

        let doc_values = super.get_values(true);

        if (!doc_values) return;

        frappe.web_form.events.trigger('on_save', this);
        this.on_save && this.on_save();

        if (this.cancelSave) return;

        if (window.saving) return;
        let for_payment = Boolean(this.accept_payment && !this.doc.paid);

        if (!this.doc) this.doc = {}
        Object.assign(this.doc, doc_values);
        this.doc.doctype = this.doc_type;
        this.doc.web_form_name = this.name;

        // Save
        window.saving = true;
        frappe.form_dirty = false;

        let doc = this.doc
        if (($.isPlainObject(doc) || $.isArray(doc))) {
            doc = JSON.stringify(doc)
        }
        return frappe.call({
            type: "POST",
            method: this.webform_controller + ".accept",
            args: {
                data: doc,
                web_form: this.name,
                docname: this.doc.name,
                for_payment
            },
            freeze: true,
            callback: response => {
                // Check for any exception in response
                if (!response.exc) {
                    // Success
                    frappe.web_form.doc = response.message;
                    frappe.web_form.set_field_values();
                    frappe.web_form.events.trigger('after_save');
                    //frappe.web_form.events.after_save.broadcast(this);
                    if (!silent) this.handle_success(response.message, this.success_message);
                }
            },
            always: function () {
                window.saving = false;
            }
        });
    }

    delete() {
        frappe.confirm("Delete: Are you sure?", () => {
            frappe.call({
                type: "POST",
                method: this.webform_controller + ".delete",
                args: {
                    web_form_name: this.name,
                    docname: this.doc.name
                },
                freeze: true,
                callback: response => {
                    // Check for any exception in response
                    if (!response.exc) {
                        // Success
                        //frappe.web_form.events.after_delete.broadcast(this);
                        frappe.web_form.events.trigger('after_delete', this);
                        window.location.href = window.location.pathname;
                    }
                },

            });
        });
    }

    print(format) {
        window.open(`/printview?
			doctype=${this.doc_type}
			&name=${this.doc.name}
			&format=${format || this.print_format || "Standard"}`, '_blank');
    }

    cancel() {
        window.location.href = window.location.pathname;
    }

    handle_success(data, message, redirect_override) {
        if (this.accept_payment && !this.doc.paid) {
            window.location.href = data;
        }

        const success_dialog = new frappe.ui.Dialog({
            title: __("Saved Successfully"),
            primary_action_label: "Ok",
            primary_action: () => {
                if (redirect_override) {
                    window.location.href = redirect_override;
                } else if (this.success_url) {
                    window.location.href = this.success_url;
                } else if (this.login_required) {
                    if (window.location.search != "?name=" + encodeURIComponent(data.name))
                        window.location.href =
                            window.location.pathname + "?name=" + encodeURIComponent(data.name);
                } else {
                    window.location.href = window.location.pathname;
                }
                success_dialog.hide();
                // if (frappe.web_form.workflow.transitions.length > 0)
                //             frappe.show_alert("Don't forget to submit!");
            }
        });
        success_dialog.no_cancel();
        //success_dialog.$wrapper.find("button.close").toggle(false); //bug fix for frappe msg issue.
        success_dialog.show();
        const success_message =
            message || __("Your information has been saved");
        success_dialog.set_message(success_message);
    }
}
